<template>
    <div>
        <card-header title="Edit Configuration (Legacy)" icon="fa-pencil"/>

        <card-body>

            <card-list>
                <subheader-list-item icon="fa-align-left" title="Information"/>

                <container-list-item padded no-border>
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="config.name"></b-input>
                    </b-field>

                    <div class="columns">
                        <div class="column">
                            <b-field label="Hours" label-position="inside">
                                <b-input v-model="config.units" type="number"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Flat Price" label-position="inside">
                                <b-input v-model="config.flatprice" type="number"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Per Hour Price" label-position="inside">
                                <b-input v-model="config.price" type="number"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>



                <subheader-list-item icon="fa-align-left" title="Flags"/>
                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <b-switch :true-value="1" :false-value="0" v-model="config.hybrid"><strong>Hybrid Log</strong></b-switch>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field>
                                <b-switch :true-value="1" :false-value="0" v-model="config.lock_log"><strong>Lock Log</strong></b-switch>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteConfig"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Config?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!config.name"
                    >
                        <i class="fas fa-check mr-2"></i>Save Config
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../../http_client';
    import ContainerListItem from "../../../TIER/components/ContainerListItem";

    export default {
        components: {ContainerListItem, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                config: {},
                confirmDelete: false,
                dirty: null,
            };
        },
        methods: {
            loadConfig: function(force) {
                this.$emit('loading', true);
                http.get('conferences/legacy/config/' + this.props.configId, {force}).then(response => { // TODO: temporary endpoint
                    this.config = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('conferences/legacy/config/' + this.props.configId, this.config, {force: true}).then(response => {
                    this.$reloadCard('conference-legacy');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteConfig() {
                // if (this.confirmDelete) {
                //     this.$emit('loading', true);
                //     http.delete('courses/' + this.props.courseId).then(response => {
                //         this.$reloadCard('courses');
                //         this.$saveAlert(false);
                //         this.$closeCard(this.card);
                //     }).catch(err => {
                //
                //     });
                // } else {
                //     this.confirmDelete = true;
                //     setTimeout(() => {
                //         this.confirmDelete = false;
                //     }, 3000);
                // }
            },
            reload() {
                this.loadConfig(true);
            }
        },
        watch: {
            'props.configId': function() {
                this.dirty = null;
                this.loadConfig(true);
            },
            'config': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this config? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadConfig(true);
        }
    };
</script>
